//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const APP_STORE_URL = 'https://apps.apple.com/us/app/fanaty/id1461051554'
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.fanaty'
const WEB_URL = 'https://www.fanaty.com/videos'

// Rutas que la app sabe abrir (mismo set que el AASA y que `linking.ts` del mobile).
const DEEP_LINK_PREFIXES = ['/l/', '/g/', '/video_detail/', '/match_detail/']

// Links de carteles/QR viejos impresos: no son rutas de la app ni están en el AASA,
// pero quien los escanea quiere abrir la app (home), no ir a la tienda.
const LEGACY_APP_PATHS = ['/views/facility-list', '/views/public-facily-list', '/views/private-facily-list']

// Cuánto esperamos a que el SO se lleve la pestaña antes de mostrar los botones.
const AUTO_REDIRECT_WATCHDOG_MS = 2500

// Cuánto esperamos al esquema `fanaty://` antes de caer a la tienda.
const SCHEME_FALLBACK_MS = 2000

export default {
  name: 'FallbackLinks',

  data() {
    return {
      isInAppBrowser: false,
      isIOS: false,
      isAndroid: false,

      // Arranca en true sólo si de verdad vamos a saltar solos; el watchdog lo
      // baja para que la pantalla siempre termine con botones.
      autoRedirecting: false,

      watchdogTimer: null,
      schemeFallbackTimer: null,
      onVisibilityChange: null,
      onPageHide: null,
    }
  },

  computed: {
    // El deep link original. nginx redirige /l/... a /fallback_links?deepLink=/l/...
    // así que el destino llega por query; el fullPath es el fallback.
    deepLinkPath() {
      const { deepLink } = this.$route.query
      const raw = deepLink || this.$route.fullPath

      return decodeURIComponent(String(raw || ''))
        .replace(/^https?:\/\/[^/]+/i, '') // soporta deep links absolutos
        .replace(/^\/*/, '/') // normaliza a una sola barra inicial
    },

    hasDeepLink() {
      return DEEP_LINK_PREFIXES.some(prefix => this.deepLinkPath.startsWith(prefix))
    },

    isLegacyAppLink() {
      const [path] = this.deepLinkPath.split(/[?#]/)

      return LEGACY_APP_PATHS.includes(path.replace(/\/+$/, ''))
    },

    // Deep link real o cartel viejo: en ambos casos intentamos abrir la app.
    opensApp() {
      return this.hasDeepLink || this.isLegacyAppLink
    },

    // Custom URL Scheme: la ÚNICA forma de abrir la app cuando el universal link
    // no disparó (navegador interno de WhatsApp, o la preferencia por dominio de
    // iOS de quedarse en Safari).
    // Sin deep link (`/`, `/download`, carteles viejos) abre la home de la app:
    // `fanaty://download` sería una ruta que la app no conoce.
    schemeUrl() {
      if (!this.hasDeepLink) return 'fanaty://'

      return `fanaty://${this.deepLinkPath.replace(/^\/+/, '')}`
    },

    // URL de la página intermedia que se abre en Chrome/Safari (fuera del WebView)
    redirectPageUrl() {
      return `https://app.fanaty.com/deep-link-redirect?deepLink=${encodeURIComponent(this.deepLinkPath)}`
    },

    // intent:// abre la app si está instalada y cae solo al Play Store si no.
    // La query se conserva (`/l/r/:id?highlights=1` la necesita); lo único que
    // hay que sacar es un fragmento, que chocaría con el `#Intent;`.
    intentUrl() {
      const [cleanPath] = this.deepLinkPath.split('#')
      const fallback = encodeURIComponent(PLAY_STORE_URL)

      // El intent-filter https de la app sólo cubre /l — sin deep link (cartel
      // viejo, `/`, `/download`) va por el esquema fanaty://, que abre la home.
      if (!this.hasDeepLink) {
        return `intent://#Intent;scheme=fanaty;package=com.fanaty;S.browser_fallback_url=${fallback};end`
      }

      return `intent://app.fanaty.com${cleanPath}#Intent;scheme=https;package=com.fanaty;S.browser_fallback_url=${fallback};end`
    },

    storeUrl() {
      if (this.isIOS) return APP_STORE_URL
      if (this.isAndroid) return PLAY_STORE_URL

      return WEB_URL
    },
  },

  created() {
    const ua = navigator.userAgent || navigator.vendor || window.opera

    const isInstagram = /Instagram/i.test(ua)
    const isTikTok = /TikTok|musical_ly|BytedanceWebview/i.test(ua)
    const isFacebook = /FBAN|FBAV|FB_IAB|FacebookExternalHit/i.test(ua)

    // WhatsApp faltaba: sus links caían por el camino "normal" y, dentro de su
    // WebView, el salto a la tienda queda bloqueado sin diálogo — el spinner
    // eterno que reportaron.
    const isWhatsApp = /WhatsApp/i.test(ua)
    const isTelegram = /Telegram/i.test(ua)
    const isOtherWebView = /Line\/|Snapchat|Twitter|LinkedInApp|GSA\//i.test(ua)

    this.isInAppBrowser = isInstagram || isTikTok || isFacebook || isWhatsApp || isTelegram || isOtherWebView
    this.isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream
    this.isAndroid = /android/i.test(ua)

    // Detectar idioma del teléfono para in-app browsers si no hay preferencia previa
    if (!localStorage.getItem('lang')) {
      const browserLang = (navigator.language || '').split('-')[0]
      this.$i18n.locale = browserLang === 'es' ? 'es' : 'en'
    }

    if (this.isInAppBrowser) {
      // Android in-app browser: intent:// abre la app sola (y cae al store si no está)
      if (this.isAndroid) window.location.href = this.intentUrl

      return
    }

    this.startAutoRedirect()
  },

  beforeDestroy() {
    this.clearTimers()
  },

  methods: {
    // Qué hacemos solos al entrar, por plataforma:
    //  · Android con deep link → intent:// (abre la app o cae al Play Store)
    //  · Escritorio, o sin deep link (QR /download) → tienda / web
    //  · Los carteles viejos (/views/facility-list) cuentan como deep link a la home
    //  · iOS con deep link → NADA: `fanaty://` sin gesto del usuario dispara un
    //    diálogo y, si no está instalada, un error feo. Mostramos los botones.
    startAutoRedirect() {
      if (this.isAndroid && this.opensApp) {
        this.autoRedirecting = true
        this.armWatchdog()
        window.location.href = this.intentUrl

        return
      }

      if (this.opensApp && this.isIOS) return

      this.autoRedirecting = true
      this.armWatchdog()
      window.location.replace(this.storeUrl)
    },

    // Si a los pocos segundos seguimos acá, el salto no prendió (o lo cancelaron):
    // se muestran los botones en vez de dejar el spinner girando para siempre.
    armWatchdog() {
      this.clearTimeoutRef('watchdogTimer')
      this.watchdogTimer = setTimeout(() => {
        this.autoRedirecting = false
      }, AUTO_REDIRECT_WATCHDOG_MS)
    },

    goToStore() {
      window.location.href = this.storeUrl
    },

    openApp() {
      if (this.isIOS) {
        // iOS: window.open está bloqueado en WebViews de WhatsApp/Instagram/TikTok
        // y los Universal Links tampoco disparan ahí (WKWebView de Apple).
        // El Custom URL Scheme es el único camino que queda.
        window.location.href = this.schemeUrl

        // Si la app no está instalada, después de 2s ir al App Store
        this.clearTimeoutRef('schemeFallbackTimer')
        this.schemeFallbackTimer = setTimeout(() => {
          window.location.href = APP_STORE_URL
        }, SCHEME_FALLBACK_MS)

        // Si la app se abrió, cancelar el fallback para q no vaya al store cuando vuelva
        this.onVisibilityChange = () => {
          if (document.hidden) this.clearTimers()
        }
        this.onPageHide = () => {
          this.clearTimers()
        }
        document.addEventListener('visibilitychange', this.onVisibilityChange)
        window.addEventListener('pagehide', this.onPageHide)

        return
      }

      if (this.isAndroid) {
        // intent:// abre la app y, si no está, cae solo al Play Store
        window.location.href = this.intentUrl

        return
      }

      window.location.href = WEB_URL
    },

    clearTimeoutRef(key) {
      if (this[key]) {
        clearTimeout(this[key])
        this[key] = null
      }
    },

    clearTimers() {
      this.clearTimeoutRef('watchdogTimer')
      this.clearTimeoutRef('schemeFallbackTimer')

      if (this.onVisibilityChange) {
        document.removeEventListener('visibilitychange', this.onVisibilityChange)
        this.onVisibilityChange = null
      }
      if (this.onPageHide) {
        window.removeEventListener('pagehide', this.onPageHide)
        this.onPageHide = null
      }
    },
  },
}
